import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from "@angular/material/dialog";
import { Component, Inject, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { PollListItem } from "../user-polls.type";
import { RecurrenceType } from "../../create-poll/create-poll.type";
import { FormControl, ReactiveFormsModule, Validators } from "@angular/forms";
import { UserPollsService } from "../user-polls.service";
import { MakePollRecurrentFormComponent } from "./make-poll-reccurrent-form/make-poll-reccurrent-form.component";

@Component({
    selector: 'make-poll-recurrent-dialog',
    templateUrl: './make-poll-recurrent-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
    MatDialogActions,
    MatDialogContent,
    MatDialogTitle,
    ReactiveFormsModule,
    TranslateModule,
    MakePollRecurrentFormComponent,
]
})
export class MakePollRecurrentDialogComponent implements OnInit {

    protected poll: PollListItem;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: PollRecurrentData,
        public dialogRef: MatDialogRef<MakePollRecurrentDialogComponent>,
        protected translate: TranslateService,
        protected userPollsService: UserPollsService
    ) { }

    ngOnInit() {
        this.poll = this.data.poll;
    }

    onDurationValueChanged(poll: PollListItem) {
        this.poll = poll;
    }

    close() {
        this.dialogRef.close();
    }
    makeRecurrent() {
        this.dialogRef.close(this.poll);
    }
}

export interface PollRecurrentData {
    poll: PollListItem;
    frequency: RecurrenceType;
}